export const worksheets = {
  title: 'Munkalapok',
  subtitle: 'Sablon alapú munkalapok kezelése digitális aláírással',
  new: 'Új munkalap',
  edit: 'Munkalap szerkesztése',
  view: 'Munkalap megtekintése',
  delete: 'Munkalap törlése',
  
  // Status
  status: {
    draft: 'Vázlat',
    in_progress: 'Folyamatban',
    completed: 'Befejezve',
    cancelled: 'Törölve'
  },
  
  // Work types
  workTypes: {
    installation: 'Telepítés',
    maintenance: 'Karbantartás',
    repair: 'Javítás',
    inspection: 'Ellenőrzés',
    other: 'Egyéb'
  },
  
  // Priority
  priority: {
    low: 'Alacsony',
    medium: 'Közepes',
    high: 'Magas'
  },
  
  // Fields
  fields: {
    title: 'Munkalap címe',
    description: 'Leírás',
    customer: 'Ügyfél',
    workType: 'Munka típusa',
    status: 'Állapot',
    priority: 'Prioritás',
    dueDate: 'Határidő',
    location: 'Helyszín',
    workDetails: 'Munka részletei',
    materials: 'Anyagok',
    equipment: 'Eszközök',
    safetyNotes: 'Biztonsági megjegyzések',
    estimatedHours: 'Becsült órák',
    actualHours: 'Tényleges órák',
    signatures: 'Aláírások',
    documents: 'Dokumentumok'
  },
  
  // Actions
  actions: {
    create: 'Létrehozás',
    edit: 'Szerkesztés',
    view: 'Megtekintés',
    delete: 'Törlés',
    complete: 'Befejezés',
    sign: 'Aláírás',
    addSignature: 'Aláírás hozzáadása'
  },
  
  // Messages
  messages: {
    noWorksheets: 'Nincsenek munkalapok',
    noWorksheetsDescription: 'Kezdjen az első munkalap létrehozásával.',
    createSuccess: 'Munkalap sikeresen létrehozva',
    createError: 'Hiba történt a munkalap létrehozásakor',
    updateSuccess: 'Munkalap sikeresen frissítve',
    updateError: 'Hiba történt a munkalap frissítésekor',
    deleteSuccess: 'Munkalap sikeresen törölve',
    deleteError: 'Hiba történt a munkalap törlésekor',
    confirmDelete: 'Biztosan törölni szeretné ezt a munkalapot?',
    confirmTitle: 'Munkalap törlése',
    deleteQuestion: 'Biztosan törölni szeretné ezt a munkalapot?',
    deleteWarning: 'Ezt a műveletet nem lehet visszavonni!',
    signatureAdded: 'Aláírás sikeresen hozzáadva',
    signatureError: 'Hiba történt az aláírás hozzáadásakor',
    completed: 'Munkalap befejezve',
    completedError: 'Hiba történt a munkalap befejezésekor'
  },
  
  // Filters
  filters: {
    all: 'Összes',
    allTypes: 'Minden típus',
    byStatus: 'Állapot szerint',
    byType: 'Típus szerint'
  }
}; 